<template lang="pug">
#loading

  .background
    .lines
      ul
        li.lines-bg
        li.lines-bg
    .overlay

  //- .bg-full

  .pad-top

  //- SWOOSH
  transition(name='swoosh')
    swoosh-icon.swoosh(v-if="!loadCompleted")

  loading-text(v-bind:completed="loadCompleted")

  .bottom

    transition(name='load-section')
      div(v-show="!loadCompleted")
        progress-bar(
          v-bind:time="updateTime"
          v-bind:progress="showProgress"
        )

    transition(name='load-section')
      div(v-show="loadCompleted")
        button.start(
          v-on:click="next"
        )
          img.bg(src="~assets/result/btn-blue.png")
          .content
            span {{ $t('startCta')}}

</template>

<script>
import Vue from 'vue'
import {mapState} from 'vuex'
import ProgressBar from './ProgressBar'
import LoadingText from './LoadingText'
import {getProgress} from 'src/components/game/loader.js'
import game from 'src/components/game/main'
import {service as ShareService} from 'src/api/ShareService'
import {service as AnalyticsService} from 'src/api/AnalyticsService'
import {config as gameConfig} from 'src/components/game/config'
import SwooshIcon from 'src/assets/swoosh.svg'
import i18n from 'src/i18n'

export default {
  name: 'loading',
  components: {
    ProgressBar,
    LoadingText,
    SwooshIcon
  },
  data () {
    return {
      updateTime: 100,
      showProgress: 0,
      startTime: Date.now(),
      minTime: 1000,
      loadCompleted: false
    }
  },
  computed: {
    ...mapState({
      loadProgress: state => state.game.loading.progress
    })
  },
  mounted: function() {

    window.loading = this

    AnalyticsService.sendPageview('/')

    ShareService.init().then(()=>{
      ShareService.setDefaultLink()
    })

    // ON READY
    if (document.readyState === 'complete') {
      this.onDocumentReady()
    } else {
      document.onreadystatechange = ()=> {
        if (document.readyState === 'complete') {
          this.onDocumentReady()
        }
      }
    }


  },
  beforeDestroy: function() {
  },
  methods: {
    onDocumentReady () {
      setTimeout(()=> {
        this.update()
        game.loader.start()
      }, 60)
    },
    update () {

      this.interval = setInterval(()=> {
        getProgress()
        // console.log(1111, progress)
        let actualProgress = Math.round(this.loadProgress * 100) / 100
        let maxProgress = (Date.now() - this.startTime) / this.minTime
        maxProgress = Math.min(maxProgress, 1)

        let showProgress = Math.min(actualProgress, maxProgress)
        this.showProgress = Math.min(showProgress, 1)
        // console.log(this.loadProgress, actualProgress, maxProgress, this.showProgress)

        if (this.loadProgress >= 1 && showProgress >= 0.98) {
          clearInterval(this.interval)
          this.onComplete()
        }

      }, this.updateTime * 2)

    },
    onComplete () {
      this.showProgress = 1
      const duration = Date.now() - this.startTime
      console.log(`##### LOADED ##### ${Math.round(duration)}ms`)
      Vue.nextTick(()=> {
        this.loadCompleted = true
        if (gameConfig.skipEnterButton) {
          this.next()
        }
      })
    },
    next () {
      let route = {
        name: 'race'
      }

      // if (i18n.locale === 'en') {
      //   route.query = {
      //     '_locale': 'en'
      //   }
      // }

      this.$router.replace(route)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

#loading
  +full()
  +flex-center()
  background: rgba(0,0,0,1)
  color: white

// @keyframes bg
//   0%
//     background-position: 0 0
//   100%
//     background-position: -100vw 0

@keyframes bg
  0%
    transform: translateX(0%)
  100%
    transform: translateX(-100%)


.background
  +full()
  .lines
    +full()
    transform: skew(-22deg) scale(1.3)

    ul
      width: 100%
      height: 100%
      border: 2px solid red
      white-space: nowrap
      font-size: 0
      animation: bg 4s linear infinite

    .lines-bg
      display: inline-block
      height: 100%
      width: 100%
      background: url('~src/assets/loading/lines.png')
      background-size: 100% 100%
      background-repeat: repeat-x

      // &:nth-child(2)
      //   filter: brightness(0.5)

  .overlay
    +full()
    background: linear-gradient(-22deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 1) 100%)

.bg-full
  +full()
  background: url('~src/assets/loading/bg.jpg')
  background-size: cover

.pad-top
  position: relative
  height: 80px

.swoosh
  position: absolute
  top: $ui-padding * 2
  left: 0
  right: 0
  margin: 0 auto
  height: 5vmin
  fill: white

.bottom
  position: relative
  height: 80px
  width: 100%

  >div
    +full()
    +flex-center()


button
  position: relative
  font-size: 0
  font-weight: normal

  .bg
    width: 150px
    max-width: 150px
    transform: skew(-13deg)

  .content
    +full()
    +flex-center()
    width: 80%
    align-items: flex-start
    padding-left: 15%

    span
      color: white
      font-size: 15px
      // font-style: italic
      white-space: nowrap
      transform: skew(-22deg)



.load-section-enter-active,
  transition: all 0.6s ease 0.4s

.load-section-enter
  opacity: 0

.load-section-leave-active
  transition: all 0.6s ease 0s
  opacity: 0


.swoosh-section-enter-active,
  transition: all 0.6s ease 0s

.swoosh-section-enter
  opacity: 0

.swoosh-section-leave-active
  transition: all 0.6s ease 0s
  opacity: 0

</style>



// WEBPACK FOOTER //
// Loading.vue?6effab3b